export const CATS_FETCHED = 'CATS_FETCHED';
export const IMAGE_FETCHED = 'IMAGE_FETCHED';
export const MEDIA_FETCHED = 'MEDIA_FETCHED';
export const PROJECTS_FETCHED = 'PROJECTS_FETCHED';
export const RESET_CATS = 'RESET_CATS';
export const SET_CATS = 'SET_CATS';
export const SET_FILTERING = 'SET_FILTERING';
export const SET_PROJECTS = 'SET_PROJECTS';
